<template>
  
  <div>
    
    <!-- <span v-if="buttonIsActive"> -->
        <input type="text" v-model="singleKeyword" v-on:buttonIsActive="tossKeywords" v-on:keyup.enter="tossKeywords">
        <!-- <span v-on:click="tossKeywords"  class="inputBtn"> 검색 </span> -->
        <span class="searchButton" v-on:click="showInputBox"><i class="fas fa-search fa-1x"></i></span>
     <!-- </span> -->
    
  </div>
</template>

<script>

    export default {

        props: ['buttonIsActive'],

        data: function() {

          
            return {

                singleKeyword: ""
                
            }

        },

        methods: {

            tossKeywords: function() {

                if(this.singleKeyword !== '') {

                    this.$emit('tossKeywords', this.singleKeyword);
                    this.$emit('addKeywords', this.singleKeyword);
                    console.log("여기는 인풋 컴포넌트! 키워드는", this.singleKeyword);
                    this.singleKeyword = "";

                }
              
            },

            showInputBox: function() {

              this.$emit('clickSearch', this.singleKeyword);
              this.$emit('addKeywords', this.singleKeyword);

            }
        

        }   

    }

</script>

<style scoped>

.searchButton {

cursor: pointer;

}

input:focus {
   border-bottom: solid 1px black;
   border-left:none;
   border-right: none;

}

input {
  
  outline: none;
  border-top:none;
  border-left:none;
  border-right: none;

  height: 40px;
  width: 680px;
  box-sizing: border-box;
  font-size: 1.2rem;
   
}
   
</style>